import omit from 'lodash/omit';
import VueRouter, {
  NavigationGuard,
  RawLocation, Route,
} from 'vue-router';
import {
  Store,
} from 'vuex';

import {
  authTokenStorage,
} from '@/plugins/auth-token-storage';
import {
  NavigationGuardNext,
} from '@/store/types';
import {
  getAuthDataInLocation,
  hasAuthDataInLocation,
} from '@/utils/auth-helpers';
import {
  isLocalDevelopment,
} from '@/utils/stage-check';

const LOGIN_PARAMS = [
  'access_token',
  'expiry',
  'refresh_token',
  'token_type',
];

export const setToken = (store: Store<{}>, router: VueRouter): NavigationGuard => {
  const hook: NavigationGuard = (to: Route, from: Route, next: NavigationGuardNext) => {
    const isAuthenticated = store.getters['auth/isAuthenticated'];
    let updatedRoute: RawLocation = {};

    if (authTokenStorage.accessToken && !isAuthenticated) {
      store.dispatch('auth/setCookies', authTokenStorage.value);

      updatedRoute = {
        name: to.name || void 0,
        params: to.params,
        query: omit(to.query, LOGIN_PARAMS),
      };
    } else if (
      isLocalDevelopment()
      && /^http(s)?:\/\/localhost/u.test(window.location.href)
      && hasAuthDataInLocation()
    ) {
      if (!isAuthenticated) {
        store.dispatch('auth/setCookies', getAuthDataInLocation());
      }

      updatedRoute = {
        name: to.name || void 0,
        params: to.params,
        query: omit(to.query, LOGIN_PARAMS),
      };
    }

    const hookIndex = router.beforeHooks.findIndex((_: NavigationGuard) => _ === hook);
    if (hookIndex !== -1) {
      router.beforeHooks.splice(hookIndex, 1);
    }

    next(updatedRoute);
  };

  return hook;
};
